module.exports = __webpack_public_path__ + "static/media/orpeglogo.1542b13d.png";